import React from "react";

const SvgYearBuilt = (props) => (
  <svg width={22} height={30} {...props}>
    <g stroke="#082746" fill="none" fillRule="evenodd">
      <path d="M11.34 10.018a1.5 1.5 0 00-.704 1.934l6.81 15.804a1.5 1.5 0 002.05.747l.784-.394a1.5 1.5 0 00.704-1.934l-6.81-15.804a1.5 1.5 0 00-2.05-.746l-.784.393z" />
      <path
        d="M1.86 6.107L12.72.901c.445-.227 2.328-.342 2.883-.356 2.89-.073 5.29-.075 5.413.21.122.284.394.426-2.313 3.47-.393.443-2.792 3.16-3.203 3.367L4.826 12.958c-1.134.57-2.46.09-2.96-1.074L.725 9.24c-.119-.814-.113-1.4.017-1.758.13-.358.502-.816 1.118-1.375z"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default SvgYearBuilt;
